<template>
  <a-drawer
    :destroy-on-close="true"
    :mask-closable="false"
    :title="isUpdate ? '文档编辑' : '文档创建'"
    :visible="visible"
    :width="1200"
    @close="closeDrawer"
  >
    <a-form-model
      ref="form"
      :label-col="{
        span: 4,
        style: {
          textAlign: 'left'
        }
      }"
      :model="form"
      :rules="rules"
      :wrapper-col="{
        span: 20
      }"
    >
      <a-form-model-item label="名称" prop="name">
        <a-input v-model="form.name" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item
        :label-col="{
          span: 0
        }"
        prop="content"
        :wrapper-col="{
          span: 24
        }"
      >
        <rich-text v-model="form.content"></rich-text>
      </a-form-model-item>
      <a-form-model-item>
        <a-space size="middle">
          <a-button :loading="loading" type="primary" @click="ok">
            确定
          </a-button>
          <a-button @click="closeDrawer">取消</a-button>
        </a-space>
      </a-form-model-item>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { createDocument, getDocument, updateDocument } from '@/api/document'
import RichText from '@/components/RichText'

export default {
  name: 'InputDrawer',
  components: {
    RichText
  },
  data () {
    return {
      isUpdate: false,
      visible: false,
      form: {
        id: '',
        name: '',
        content: ''
      },
      rules: {
        name: [
          {
            message: '请输入名称',
            required: true,
            trigger: 'blur'
          }
        ],
        content: [
          {
            message: '请输入内容',
            required: true,
            trigger: 'blur'
          }
        ]
      },
      loading: false
    }
  },
  methods: {
    show (id) {
      if (id) {
        this.isUpdate = true
        getDocument(id)
          .then(res => {
            const data = res.data
            this.form = {
              id: data.id,
              name: data.name,
              content: data.content
            }
          })
          .finally(() => {
            this.visible = true
          })
      } else {
        this.isUpdate = false
        this.visible = true
      }
    },
    closeDrawer () {
      this.form = {
        id: '',
        name: '',
        content: ''
      }
      this.$refs.form.resetFields()
      this.visible = false
    },
    ok () {
      this.$refs.form.validate(valid => {
        if (valid) {
          const params = {}
          if (this.form.name) params.name = this.form.name
          if (this.form.content) params.content = this.form.content
          this.loading = true
          if (this.isUpdate) {
            updateDocument(this.form.id, params)
              .then(res => {
                this.$message.success(res.message)
                this.$emit('ok')
                this.closeDrawer()
              })
              .finally(() => {
                this.loading = false
              })
          } else {
            createDocument(params)
              .then(res => {
                this.$message.success(res.message)
                this.$emit('ok')
                this.closeDrawer()
              })
              .finally(() => {
                this.loading = false
              })
          }
        }
      })
    }
  }
}
</script>
